export default __webpack_public_path__ + "static/media/lv.01350951.svg";